import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  hint?: ReactNode;
}

export function Card({ title, hint, className, children, ...rest }: CardProps) {
  return (
    <section
      className={cx(
        'bg-linen border border-rule rounded-none',
        'p-6',
        className,
      )}
      {...rest}
    >
      {(title || hint) && (
        <header className="mb-4 flex items-baseline justify-between gap-4">
          {title ? <h3 className="display text-lg">{title}</h3> : <span />}
          {hint ? <span className="smallcap">{hint}</span> : null}
        </header>
      )}
      {children}
    </section>
  );
}
